import { InvoiceDetailModel, InvoiceModel, InvoiceStatus } from '@frontend/api-invoices';

export const isSuccessfullyPaidInvoice = (invoice: InvoiceModel) =>
  !!invoice.payment &&
  (invoice.status === InvoiceStatus.Paid ||
    invoice.status === InvoiceStatus.PartiallyPaid ||
    invoice.payment?.status === 'SUCCEEDED');

export const isCanceledInvoice = (invoice: InvoiceModel) => invoice.status === InvoiceStatus.Canceled;

export const isPaidInvoice = (invoice: InvoiceModel | InvoiceDetailModel | undefined) =>
  !!invoice &&
  (isSuccessfullyPaidInvoice(invoice) ||
    invoice.payment?.status === 'PENDING' ||
    invoice.status === InvoiceStatus.Pending);

export const isFailedInvoice = (invoice: InvoiceModel) =>
  !!invoice.payment && invoice.payment.status === 'FAILED' && invoice.status !== InvoiceStatus.Paid;

export const isPartialPayment = (invoice: InvoiceModel) =>
  !!invoice.payment && invoice.billedAmount - invoice.payment.paidAmount > 0;

export const isCompletelyPaid = (invoice: InvoiceModel) => isPaidInvoice(invoice) && !isPartialPayment(invoice);
